import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import TableInfoApprovedBenefits from './ tableInfoApprovedBenefits';
import { benefitsAPI } from './actions';

const ShowInfoApprovedBenefits = () => {
  const [email, setEmail] = useState('');
  const [dateFrom, setDateFrom] = useState('2018-09-01');
  const [dateTo, setDateTo] = useState(new Date().toISOString().split('T')[0]);
  const [showTable, setShowTable] = useState(false);
  const [info, setInfo] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const validateEmail = (email) => {
    return email.match(/[a-z,\d]{1,30}[@]{1}[a-z,\d,.]{1,30}/);
  };

  const handleGetInfo = async () => {
    setError('');
    setShowTable(false);

    if (!validateEmail(email)) {
      setError('Невірний формат пошти');
      return;
    }

    setLoading(true);

    try {
      const result = await benefitsAPI.getApprovedBenefits(email, dateFrom, dateTo);
      
      if (result.success) {
        setInfo(result.data);
        setShowTable(true);
      } else {
        setError('Не вдалося отримати дані');
      }
    } catch (err) {
      setError(`Помилка: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleGetInfo();
  };

  return (
    <div>
      {/* Основной контент */}
      <div className="container-fluid">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8">
              <div className="card shadow-sm">
                <div className="card-body">
                  {error && (
                    <div className="alert alert-danger" role="alert">
                      {error}
                    </div>
                  )}

                  <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                      <label htmlFor="email" className="form-label">
                        Email адреса *
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        id="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Введіть email адресу"
                        required
                      />
                      <div className="form-text">Формат: example@domain.com</div>
                    </div>

                    <div className="row mb-3">
                      <div className="col-md-6">
                        <label htmlFor="dateFrom" className="form-label">
                          Дата з
                        </label>
                        <input
                          type="date"
                          className="form-control"
                          id="dateFrom"
                          value={dateFrom}
                          onChange={(e) => setDateFrom(e.target.value)}
                        />
                      </div>
                      <div className="col-md-6">
                        <label htmlFor="dateTo" className="form-label">
                          Дата по
                        </label>
                        <input
                          type="date"
                          className="form-control"
                          id="dateTo"
                          value={dateTo}
                          onChange={(e) => setDateTo(e.target.value)}
                        />
                      </div>
                    </div>

                    <div className="d-grid gap-2">
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={loading}
                      >
                        {loading ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Завантаження...
                          </>
                        ) : (
                          'Отримати інформацію'
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Таблица с результатами */}
      {showTable && (
        <TableInfoApprovedBenefits info={info} />
      )}

      {showTable && info.length === 0 && (
        <div className="container-fluid mt-4">
          <div className="container">
            <div className="alert alert-info" role="alert">
              За вказаними параметрами даних не знайдено
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ShowInfoApprovedBenefits;